import { useState, forwardRef, useImperativeHandle } from "react";
import { Modal } from "semantic-ui-react";
import ApplyTagForm from "../forms/ApplyTagForm";

const ApplyTagModal = forwardRef(({ onApplyTag }, ref) => {
  const [open, setOpen] = useState(false);
  const [tag, setTag] = useState({});

  const handleOpen = tag => {
    setTag(tag);
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async metadata => {
    await onApplyTag(tag, metadata);
    handleClose();
  };

  return (
    <Modal
      size="tiny"
      open={open}
      onClose={handleClose}
      closeOnDimmerClick={false}
    >
      <Modal.Header>Apply Tag</Modal.Header>
      <Modal.Content>
        <ApplyTagForm
          key={`tag-${tag?.id}`}
          tag={tag}
          onSubmit={handleSubmit}
          onCancel={handleClose}
        />
      </Modal.Content>
    </Modal>
  );
});

export default ApplyTagModal;
